export default "__VITE_ASSET__BL3gzY2p__"